"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Documents = exports.Complete = exports.AllGroups = exports.Spec = exports.Groups = exports.TITLE = exports.NAMESPACE = exports.Tracing = exports.Tenant = exports.Rules = exports.RateLimit = exports.Legacy = exports.Error = exports.Devices = exports.Device = exports.Dashboard = exports.Authorization = exports.Alarm = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const device_1 = require("../../../device");
const Compose = __importStar(require("../../openapi/compose"));
const Alarm = __importStar(require("./alarm"));
const Dashboard = __importStar(require("./dashboard"));
const Device = __importStar(require("./device"));
const Devices = __importStar(require("./devices"));
const Legacy = __importStar(require("./legacy"));
const RateLimit = __importStar(require("./rate-limit"));
const Rules = __importStar(require("./rules"));
exports.Alarm = __importStar(require("./alarm"));
exports.Authorization = __importStar(require("./authorization"));
exports.Dashboard = __importStar(require("./dashboard"));
exports.Device = __importStar(require("./device"));
exports.Devices = __importStar(require("./devices"));
exports.Error = __importStar(require("./error"));
exports.Legacy = __importStar(require("./legacy"));
exports.RateLimit = __importStar(require("./rate-limit"));
exports.Rules = __importStar(require("./rules"));
exports.Tenant = __importStar(require("./tenant"));
exports.Tracing = __importStar(require("./tracing"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec';
exports.TITLE = 'Unified API - Version 2';
const ServerSentEvents = effect_1.Schema.Union(device_1.TroubleshootingChat.Event);
const { $defs: serverSentEventSchemas } = platform_1.OpenApiJsonSchema.make(ServerSentEvents);
// Inject Server Sent Event response schemas.
// See https://github.com/Effect-TS/effect/issues/6048
const injectServerSentEvents = (spec) => ({
    ...spec,
    components: {
        ...spec['components'],
        schemas: {
            ...spec['components']?.schemas,
            ...serverSentEventSchemas,
        },
    },
});
/** The empty v2 API: wire-protocol errors plus the API-wide rate limit. */
const base = () => Compose.makeApi('v2').middleware(RateLimit.RateLimit);
/** Prefix, title and SSE schema injection shared by every v2 document. */
const finalize = (api, title = exports.TITLE) => api
    .prefix(Compose.versionPrefix(Compose.Version.V2))
    .annotate(platform_1.OpenApi.Title, title)
    .annotate(platform_1.OpenApi.Transform, injectServerSentEvents);
/** The typed endpoint groups implemented by the unified-api handlers. */
exports.Groups = [
    Dashboard.Spec,
    Device.Spec,
    Devices.Spec,
    Alarm.Spec,
    Rules.RulesSpec,
    Rules.ChannelsSpec,
];
/**
 * The served v2 contract.
 *
 * Groups are added one by one (rather than from {@link Groups}) so the precise
 * group types survive for `HttpApiBuilder.group(Spec, '<name>', ...)`.
 */
exports.Spec = finalize(base()
    .add(Dashboard.Spec)
    .add(Device.Spec)
    .add(Devices.Spec)
    .add(Alarm.Spec)
    .add(Rules.RulesSpec)
    .add(Rules.ChannelsSpec));
/** Every v2 group: the typed ones above plus the documentation-only legacy contracts. */
exports.AllGroups = [...exports.Groups, ...Legacy.Groups];
/**
 * The complete v2 documentation root. Never served: it contains contracts
 * without handlers, so it is only ever converted with `OpenApi.Generate`.
 */
exports.Complete = finalize(Compose.addGroups(base(), exports.AllGroups));
/** One v2 document per audience (admin, user, device, fleet, system). */
exports.Documents = Compose.documents(exports.AllGroups, (audience, groups) => finalize(Compose.addGroups(base(), groups), `${exports.TITLE} - ${Compose.documentTitle(audience)}`));
//# sourceMappingURL=index.js.map